import WDBox from "../../../../../MaterialComponents/WDBox";
import {
  Grid,
  TextField,
  Typography,
  Checkbox,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const FIELD_TYPES = ["TEXT", "IMAGE", "PDF", "DOCUMENT"];
const ServiceField = (props) => {
  const { onRemove, item, onFieldTypeChange, onFieldTitleChange, onFieldMandatoryChange } = props;
  const { title, type, mandatory } = item;
  const actionButton = () => {
    return (
      <WDBox
        display="flex"
        flexDirection="column"
        flexGrow={1}
        alignItems="center"
        justifyContent="center"
        height="100%"
      >
        <DeleteIcon onClick={() => onRemove(item)} />
      </WDBox>
    );
  };

  const _isValid = () => {
    return title && title.trim().length != 0 && type && type.trim().length != 0;
  };

  return (
    <WDBox
      my={2}
      p={2}
      sx={{
        border: 1,
        borderColor: _isValid() ? "grey.300" : "error.main",
        borderRadius: "10px",
      }}
    >
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <WDBox height="100%" display="flex" alignItems="center" justifyContent="center">
            <TextField
              fullWidth
              label="Title"
              variant="outlined"
              size="small"
              value={title}
              onChange={(event) => {
                onFieldTitleChange(item, event.target.value);
              }}
            />
          </WDBox>
        </Grid>
        <Grid item xs={4}>
          <WDBox height="100%" display="flex" alignItems="center" justifyContent="center">
            <FormControl fullWidth>
              <InputLabel id="service-label">Field Type</InputLabel>
              <Select
                label="Field Type"
                fullWidth
                onChange={(event) => {
                  onFieldTypeChange(item, event.target.value);
                }}
                value={type}
                size="small"
                style={{ fontSize: "14px" }}
              >
                {FIELD_TYPES.map((type) => (
                  <MenuItem style={{ fontSize: "14px" }} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </WDBox>
        </Grid>
        <Grid item xs={2}>
          <WDBox
            display="flex"
            flexGrow={1}
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            height="100%"
          >
            <Typography variant="subtitle1" fontSize={12}>
              Is Mandatory
            </Typography>
            <Checkbox
              checked={mandatory}
              onChange={(event) => {
                onFieldMandatoryChange(item, event.target.checked);
              }}
            />
          </WDBox>
        </Grid>
        <Grid item xs={2}>
          {actionButton()}
        </Grid>
      </Grid>
    </WDBox>
  );
};

export default ServiceField;
